import React from 'react';
import { Link } from 'react-router-dom';

const POSTS = [
  { to: '/blog/trip-across-america', title: 'A trip across America', date: 'January 13, 2025' },
];

const Blog = () => (
  <div className="page page--narrow">
    <header className="page-header">
      <h1 className="page-title">Writing</h1>
      <p className="page-lead">Occasional notes on trips, books, and whatever else sticks.</p>
    </header>

    <ul className="post-list">
      {POSTS.map((post) => (
        <li key={post.to} className="post-list-item">
          <Link to={post.to}>
            <span className="post-list-title">{post.title}</span>
            <time className="post-list-date">{post.date}</time>
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default Blog;
